import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
import { MediaInterface } from '../../../interfaces'

@Component({
  selector: 'dmmp-banner-item-detail',
  templateUrl: './banner-item-detail.component.html'
})
export class BannerItemDetailComponent implements OnInit {

  @Input() data
  @Output() page = new EventEmitter()
  @Output() anchorCustom = new EventEmitter()
  @Input() truncateLength = 92
  medias : MediaInterface[] = [
    {style: 'large', media: '(min-width:1301px)'},
    {style: 'max_1300x1300', media: '(max-width:1300x) AND (min-width: 651px)'},
    {style: 'max_650x650', media: '(max-width:650px) AND (min-width: 326px)'},
    {style: 'max_325x325', media: '(max-width:325px)'},
  ]
  constructor() {}

  ngOnInit() {
  }

  ancla(event, data) {
    if (data.indexOf('#') === 0 && data.length > 1) {
      this.anchorCustom.emit(event)
    }
  }
}
